import { createPinia } from 'pinia'

/** 獨立 Pinia 實例，供非元件環境（如 Axios interceptor）使用 */
export const piniaInstance = createPinia()
